import Types from './Title.sizes';

export const title = ({ size, link, theme: { colors, fonts }, type, columns }) => {
    const base = {
        ...fonts.heroNewBold,
        fontStretch: 'normal',
        color: colors.black,
        gridColumn: columns && `auto / span ${columns}`,
    };

    const h1base = {
        fontSize: '2rem',
        lineHeight: 1.128,

        tablet: {
            fontSize: '3.75rem',
        },

        tabletLarge: {
            fontSize: '4.875rem',
        },
    };

    const h2Base = {
        fontSize: '2rem',
        lineHeight: 1.2142857143,
        color: colors.blue,

        tablet: {
            fontSize: '3.5rem',
            lineHeight: 1.25,
        },
    };

    const h3base = {
        fontSize: '2rem',
        lineHeight: 1.2083,

        tablet: {
            fontSize: '3rem',
            lineHeight: 1.2083,
        },
    };

    const h4Base = {
        fontSize: '2rem',
        lineHeight: 1.3125,
        color: colors.black,

        tablet: {
            fontSize: '2rem',
            lineHeight: 1.3125,
        },
    };

    if (link) {
        base.textDecoration = 'underline';
    }

    if (type) {
        size = type;
    }

    switch (size) {
        case Types.H1:
            return Object.assign(base, {
                ...h1base,
            });

        case Types.H1_UPPERCASE:
            return Object.assign(base, {
                ...h1base,
                textTransform: 'uppercase',
            });

        case Types.H1_ITALIC:
            return Object.assign(base, {
                ...h1base,
                fontStyle: 'italic',
            });

        case Types.H1_ITALIC_UPPERCASE:
            return Object.assign(base, {
                ...h1base,
                fontStyle: 'italic',
                textTransform: 'uppercase',
            });

        case Types.H1_LINK:
            return Object.assign(base, {
                ...h1base,
                color: colors.blue,
                boxShadow: `inset 0 -0.1875rem ${colors.blue}`,
                display: 'inline',
            });

        case Types.H1_LINK_ITALIC:
            return Object.assign(base, {
                ...h1base,
                color: colors.blue,
                boxShadow: `inset 0 -0.1875rem ${colors.blue}`,
                display: 'inline',
                fontStyle: 'italic',
            });

        case Types.H1_LINK_ITALIC_UPPERCASE:
            return Object.assign(base, {
                ...h1base,
                color: colors.blue,
                boxShadow: `inset 0 -0.1875rem ${colors.blue}`,
                display: 'inline',
                fontStyle: 'italic',
                textTransform: 'uppercase',
            });

        case Types.H2:
            return Object.assign(base, {
                ...h2Base,
            });

        case Types.H2_ITALIC:
            return Object.assign(base, {
                ...h2Base,
                fontStyle: 'italic',
            });

        case Types.H2_LINK:
            return Object.assign(base, {
                ...h2Base,
                boxShadow: `inset 0 -0.1875rem ${colors.blue}`,
                display: 'inline',
            });

        case Types.H2_LINK_ITALIC:
            return Object.assign(base, {
                ...h2Base,
                boxShadow: `inset 0 -0.1875rem ${colors.blue}`,
                display: 'inline',
                fontStyle: 'italic',
            });

        case Types.H2_LINK_ITALIC_UPPERCASE:
            return Object.assign(base, {
                ...h2Base,
                boxShadow: `inset 0 -0.1875rem ${colors.blue}`,
                display: 'inline',
                fontStyle: 'italic',
                textTransform: 'uppercase',
            });

        case Types.H3:
            return Object.assign(base, {
                ...h3base,
            });

        case Types.H3_LINK:
            return Object.assign(base, {
                ...h3base,
                color: colors.blue,
                boxShadow: `inset 0 -0.1875rem ${colors.blue}`,
                display: 'inline',
            });

        case Types.H4:
            return Object.assign(base, {
                ...h4Base,
            });

        case Types.H4_LINK:
            return Object.assign(base, {
                fontSize: '2rem',
                color: colors.blue,
                boxShadow: `inset 0 -0.1875rem ${colors.blue}`,
                display: 'inline',
            });

        case Types.H5:
            return Object.assign(base, {
                fontSize: '1.5rem',
                lineHeight: '2rem',
            });

        default:
            return base;
    }
};
